import { render, staticRenderFns } from "./ModalInternalStateHistory.vue?vue&type=template&id=56242a4d&scoped=true&"
import script from "./ModalInternalStateHistory.vue?vue&type=script&lang=js&"
export * from "./ModalInternalStateHistory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../Users/lucianocolucci/Desktop/Share Windows/IngeniAR/WebProject/Syscore-mods/Frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56242a4d",
  null
  
)

export default component.exports